"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveCreateAction = exports.useCreateCollectionDialog = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const abortable_fetch_1 = require("../../../utils/abortable-fetch");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const collection_dialog_1 = require("../collection-dialog");
const collection_schema_1 = require("../collection-schema");
function useCreateCollectionDialog(getUrl) {
    const callApi = (0, event_callback_hook_1.useEventCallback)((id, formData) => {
        return (0, abortable_fetch_1.abortableFetch)(`${getUrl(id)}`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(formData),
        });
    });
    return {
        callApi,
    };
}
exports.useCreateCollectionDialog = useCreateCollectionDialog;
function resolveCreateAction(props) {
    return {
        hide: false,
        useApi: useCreateCollectionDialog,
        label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__COLLECTION__CREATE_LABEL", defaultMessage: "Nov\u00FD" })),
        title: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__COLLECTION__CREATE_TITLE", defaultMessage: "Vytvo\u0159en\u00ED" })),
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__COLLECTION__CREATE_TEXT", defaultMessage: "Vypl\u0148te formul\u00E1\u0159" })),
        initValues: (values) => values,
        Dialog: collection_dialog_1.CollectionDialog,
        dialogWidth: 400,
        useSchema: collection_schema_1.useValidationSchema,
        ...props,
    };
}
exports.resolveCreateAction = resolveCreateAction;
//# sourceMappingURL=create-collection-hook.js.map